import React, { useState, useEffect } from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    FormControlLabel,
    Grid,
    Paper,
    Snackbar,
    Alert,
    Switch,
    TextField,
    Typography,
    MenuItem,
    Table,
      TableBody,
      TableCell,
      TableContainer,
      TableHead,
      TableRow,
      IconButton,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import VehiclesServices from "../../services/VehicleService";
import DeleteIcon from "@mui/icons-material/Delete";

const CreateVehicleModel = () => {
const [vehicleModels, setVehicleModels] = useState([]);
    const [formData, setFormData] = useState({
        make: "",
        model: "",
    });

    const [vehicleMakes, setVehicleMakes] = useState([]);

    const [errors, setErrors] = useState({});

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success"
    });

    const handleChange = (e) => {
        const { name, value, checked, type } = e.target;

        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value
        });

        setErrors({
            ...errors,
            [name]: ""
        });
    };

    const validate = () => {
        let temp = {};

        if (!formData.make) {
            temp.make = "Vehicle Make is required";
        }

        if (!formData.model.trim()) {
            temp.model = "Vehicle Model is required";
        }

        setErrors(temp);

        return Object.keys(temp).length === 0;
    };

    
    const fetchVehicleMakes = async () => {
    try {
        const response = await VehiclesServices.getVehicleMakeList();

        setVehicleMakes(response.data);

        const models = [];

        response.data.forEach((make) => {
            make.models.forEach((model) => {
                models.push({
                    id: model.id,
                    makeId: make.id,
                    make: make.make,
                    model: model.model,
                    status: model.status,
                });
            });
        });

        setVehicleModels(models);

    } catch (error) {
        console.log(error);
    }
};

useEffect(() => {
    fetchVehicleMakes();
}, []);

    const handleSave = async () => {
        if (!validate()) return;

        try {
            const payload = {
                make: Number(formData.make),
                model: formData.model.trim(),
            };

            const response = await VehiclesServices.createVehicleModel(payload);

            if (response.status === 200 || response.status === 201) {
                setSnackbar({
                    open: true,
                    message: "Vehicle Model created successfully.",
                    severity: "success",
                });

                setFormData({
                    make: "",
                    model: "",
                });

                fetchVehicleMakes();
            }
        } catch (error) {
            setSnackbar({
                open: true,
                message:
                    error?.response?.data?.message ||
                    error?.response?.data?.detail ||
                    "Failed to create Vehicle Model.",
                severity: "error",
            });
        }
    };

    const handleDelete = async (id) => {
    try {

        await VehiclesServices.deleteVehicleModel(id);

        setSnackbar({
            open: true,
            message: "Vehicle Model deleted successfully.",
            severity: "success",
        });

        fetchVehicleMakes();

    } catch (error) {

        setSnackbar({
            open: true,
            message:
                error?.response?.data?.message ||
                "Failed to delete Vehicle Model.",
            severity: "error",
        });

    }
};

    const handleReset = () => {
        setFormData({
            make: "",
            model: "",
        });

        setErrors({});
    };

    return (
        <Box p={3}>
            <Paper elevation={3}>
                <Card>
                    <CardContent>

                        <Typography
                            variant="h5"
                            fontWeight={600}
                            gutterBottom
                            sx={{ mb: 2 }}
                        >
                            Create Vehicle Model
                        </Typography>


                        <Grid container spacing={3}>

                            <Grid item xs={12} md={6}>
                                <TextField
                                    select
                                    fullWidth
                                    required
                                    label="Vehicle Make"
                                    name="make"
                                    value={formData.make}
                                    onChange={handleChange}
                                    error={Boolean(errors.make)}
                                    helperText={errors.make}
                                >
                                    <MenuItem value="">Select Vehicle Make</MenuItem>

                                    {vehicleMakes.map((item) => (
                                        <MenuItem key={item.id} value={item.id}>
                                            {item.make}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    required
                                    label="Vehicle Model"
                                    name="model"
                                    value={formData.model}
                                    onChange={handleChange}
                                    error={Boolean(errors.model)}
                                    helperText={errors.model}
                                    placeholder="e.g. Indica"
                                />
                            </Grid>

                        </Grid>

                        <Box
                            mt={4}
                            display="flex"
                            gap={2}
                        >
                            <Button
                                variant="contained"
                                startIcon={<SaveIcon />}
                                onClick={handleSave}
                            >
                                Save
                            </Button>

                            <Button
                                variant="outlined"
                                color="warning"
                                startIcon={<RestartAltIcon />}
                                onClick={handleReset}
                            >
                                Reset
                            </Button>


                        </Box>

                    </CardContent>
                </Card>
            </Paper>
<Box mt={3}>
    <Paper elevation={3}>
        <Card>
            <CardContent>

                <Typography
                    variant="h6"
                    fontWeight={600}
                    sx={{ mb: 2 }}
                >
                    Vehicle Model List
                </Typography>

                <TableContainer>
                    <Table>

                        <TableHead>
                            <TableRow>
                                <TableCell>S.No</TableCell>
                                <TableCell>Vehicle Make</TableCell>
                                <TableCell>Vehicle Model</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell align="center">Action</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>

                            {vehicleModels.length > 0 ? (
                                vehicleModels.map((item, index) => (
                                    <TableRow key={item.id}>

                                        <TableCell>{item.id}</TableCell>

                                        <TableCell>{item.make}</TableCell>

                                        <TableCell>{item.model}</TableCell>

                                        <TableCell>{item.status}</TableCell>

                                        <TableCell align="center">
                                            <IconButton
                                                color="error"
                                                onClick={() => handleDelete(item.id)}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </TableCell>

                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell
                                        colSpan={5}
                                        align="center"
                                    >
                                        No Vehicle Models Found
                                    </TableCell>
                                </TableRow>
                            )}

                        </TableBody>

                    </Table>
                </TableContainer>

            </CardContent>
        </Card>
    </Paper>
</Box>
           <Snackbar
    open={snackbar.open}
    autoHideDuration={3000}
    onClose={() =>
        setSnackbar({
            ...snackbar,
            open: false,
        })
    }
    anchorOrigin={{
        vertical: "top",
        horizontal: "right",
    }}
>
    <Alert
        onClose={() =>
            setSnackbar({
                ...snackbar,
                open: false,
            })
        }
        severity={snackbar.severity}
        variant="filled"
        sx={{ width: "100%" }}
    >
        {snackbar.message}
    </Alert>
</Snackbar>
        </Box>
    );
};

export default CreateVehicleModel;